export enum MarginValidationRule {
    basePayRateMinWage = 1,
    otPayRateMinWage = 2,
    callbackPayRateMinWage = 3,
    holidayPayRateMinWage = 4,
    yearlyStipends = 5,
    softStopOnPinkStipends = 6,
    maxRto = 7,
    softStopOnBeginningAndEndRto = 8,
    newBenefits = 9,
    ineligibleVirginIslands = 10,
    ineligibleHawaii = 11,
    ineligibleLessThan30HoursPerWeek = 12,
    ineligibleLessThan30DaysBreakInEmployment = 13,
    continuedBenefits = 14,
    qualifyingEvent = 15
}
